export function CreateArrayRegExpression(arr, caseInsensitive, strictEmpty) {
  let modifiers = "";
  if (caseInsensitive) {
    modifiers = "i";
  }

  if (strictEmpty) {
    arr = arr.map(item => {
      if (item.length === 0) {
        return "^$";
      }

      return item;
    });
  }

  const str = `(${arr.join("|")})`;
  return new RegExp(str, modifiers);
}
